export function syncCheckedAfterClick(event: Event, checked: () => boolean) {
  const input = event.currentTarget

  if (!(input instanceof HTMLInputElement)) return

  setTimeout(() => (input.checked = checked()))
}
